import {initWebComponent} from "@/helpers/web-component-helper";
import {moveLayer} from "@/helpers/ol/map/ol-move-helper";
import {showElementsBySelector} from "@/helpers/element-helper";
import {getKVLayerByBookmarkPresentationID, getKVLayerByDomainIDAndPresentationID} from "@/helpers/kv/kv-layer-helper";
import {setMutationGeometryName} from "@/helpers/tools/tools-mutation-helper";
import {getDataTableByFormIDAndFeatureID} from "@/helpers/datatable/datatable-standalone-editor-helper";

export class LayerInfoInfoItemMutationStandaloneEditGeometryComponent extends HTMLElement {
    constructor(){
        super();
        const template = document.createElement('template');
        const formID = this.getAttribute('data-form-id')
        const featureID = this.getAttribute('data-feature-id')
        const type = this.getAttribute('data-type')

        if(type === 'move') {
            template.innerHTML = `<button class="btn btn-sm btn-outline-secondary icon-btn text-transform-none popper-header mr-1" href="#">
              <span class="fa fa-arrows-alt"></span>
              <div class="popper-tooltip" role="tooltip" data-popper-placement="bottom">
                 Verplaats object
                <div class="arrow" data-popper-arrow=""></div>
              </div>
            </button>`
        } else {
            template.innerHTML = `<button class="btn btn-sm btn-outline-secondary icon-btn text-transform-none popper-header " href="#">
          <span class="fa fa-draw-polygon"></span>
          <div class="popper-tooltip" role="tooltip" data-popper-placement="bottom">
             Bewerk object geometrie
            <div class="arrow" data-popper-arrow=""></div>
          </div>
        </button>`
        }

        initWebComponent(this, template)

        this.addEventListener('click', () => {
            const dataTable = getDataTableByFormIDAndFeatureID(formID, featureID)

            const layer = getKVLayerByBookmarkPresentationID(dataTable.BookmarkPresentationID)

            setMutationGeometryName(layer.GeometryName)

            moveLayer(dataTable.BookmarkPresentationID, dataTable.FeatureID, type)

            this.closest('.card').querySelector('layer-info-info-mutation-standalone-edit-geometry-save').classList.remove('d-none')
            this.closest('.card').querySelector('layer-info-info-mutation-standalone-edit-geometry-cancel').classList.remove('d-none')
        })
    }
}
